// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-76284273]{padding:5px;min-height:33px;box-shadow:0 0 0 1px rgba(51,51,51,.239216)}.center .el-tag[data-v-76284273]{margin:2px 3px}", ""]);
// Exports
module.exports = exports;
